module.exports = __webpack_public_path__ + "static/frost_brand-5aa2565b80613aee19339ec705e284ef.jpeg";